import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-info",
  "use": "icon-user-info-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-user-info\"><defs><style>#icon-user-info .a,#icon-user-info .b{fill:none;}#icon-user-info .a{stroke:currentColor;}#icon-user-info .c{stroke:none;}</style></defs><g transform=\"translate(-382 -274)\"><g transform=\"translate(-3 73)\"><path class=\"a\" d=\"M0,0H6V16H0\" transform=\"translate(392 224) rotate(-90)\" /><g class=\"a\" transform=\"translate(395 206)\"><circle class=\"c\" cx=\"5\" cy=\"5\" r=\"5\" /><circle class=\"b\" cx=\"5\" cy=\"5\" r=\"4.5\" /></g></g><rect class=\"b\" width=\"30\" height=\"30\" transform=\"translate(382 274)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/user-info.svg
// module id = vLOi
// module chunks = 62